import type { Collection } from 'dexie';
import type { ICollection, IDBKeyType } from './interface';

function IndexedCollection<
    DataType extends Record<IDBKeyType, unknown>,
    IDType extends keyof DataType,
>(dexieCollection?: Collection<DataType, IDType>): ICollection<DataType, IDType> {
    if (!dexieCollection) {
        throw new Error(`Unable to find unnamed db collection`);
    }

    const collection: ICollection<DataType, IDType> = {
        count: dexieCollection.count.bind(dexieCollection),
        first: dexieCollection.first.bind(dexieCollection),
        keys: () =>
            new Promise((resolve, reject) => {
                dexieCollection
                    .keys()
                    .then(keys => {
                        resolve(keys as IDType[]);
                    })
                    .catch(error => {
                        reject(error);
                    });
            }),
        modify: (changeCallback: (obj: DataType) => void) =>
            new Promise((resolve, reject) => {
                let changeCount = 0;

                const dexieCB = (obj: DataType, ctx: { value: DataType }) => {
                    changeCallback(obj);
                    changeCount += 1;
                };

                dexieCollection
                    .modify(dexieCB)
                    .then(() => {
                        resolve(changeCount);
                    })
                    .catch(error => {
                        reject(error);
                    });
            }),
        toArray: dexieCollection.toArray.bind(dexieCollection),
    };

    return collection;
}

export default IndexedCollection;
